import src from "IMAGE";
export default { src, width: 464, height: 504, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
